import React, { useEffect } from 'react';

// Importing CSS Libraries
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'wowjs/css/libs/animate.css';
import '../css/style.css'; 

// Importing JavaScript Libraries
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'owl.carousel';
import '@fancyapps/fancybox';
import { WOW } from 'wowjs';
import '../js/main.js'; // Your custom scripts
import Carousel from './Carousel/Carousel.js';
import About from './about/About.js';
import Service from './service/Services.js';
import RequestCallSection from './RequestCallSection/RequestCallSection.js';
import HeroSection from '../components/HeroSection/HeroSection';
import CustomCarousel from '../components/CustomCarousel/CustomCarousel.js';
import RealEstateCarousel from './RealEstateCarousel/RealEstateCarousel.js';
import RealEstateBanner from './RealEstateCarousel/RealEstateCarousel.js';
import StockAdvisoryBanner from './RealEstateCarousel/RealEstateCarousel.js';
import { Helmet } from "react-helmet-async";

// Expose jQuery globally
window.$ = window.jQuery = $;

const RealShareAdvisor = () => {
  useEffect(() => {
    // Initialize WOW.js for animations
    const wowInstance = new WOW();
    wowInstance.init();

    // Initialize Owl Carousel
    if ($('.owl-carousel').length > 0) {
      $('.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        items: 1,
      });
    }

    // Initialize Fancybox
    if ($('[data-fancybox]').length > 0) {
      $('[data-fancybox]').fancybox();
    }

    // Hide Spinner
    const hideSpinner = () => {
      $('#spinner').fadeOut('slow', () => {
        $('#spinner').remove(); // Remove spinner from the DOM
      });
    };

    // Hide spinner on DOM load
    $(window).on('load', hideSpinner);

    // Fallback to hide spinner after 5 seconds if `window.onload` is delayed
    setTimeout(hideSpinner, 5000);

    // Smooth Scroll for Back to Top
    $('a[href="#"]').on('click', function (event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 500);
    });

    return () => {
      // Cleanup event listener
      $(window).off('load', hideSpinner);
    };
  }, []);

 return (
  <div style={{ marginTop: 0, paddingTop: 0 }}>

      <Helmet>
        <title>Option Bricks</title>
        <meta
          name="description"
          content="Learn how Option Bricks delivers data-backed research across Nifty, BankNifty, and Sensex to help traders make informed investment decisions."
        />
      </Helmet>

    {/* <StockAdvisoryBanner /> */}
    <HeroSection/>
    <RequestCallSection />
    <About />
    {/* <Service /> */}
  </div>
);

};

export default RealShareAdvisor;
